import React, { useState } from 'react';
import PsaAiBot from './psaAiBot.js';
import AiLanding from './aiLanding.js';
import OptInScreen from './optInScreen.js';
import OptOutScreen from './optOutScreen.js';
import ProvisionScreen from './provision-app/provisionScreen.js';
import ZofiQProvisionScreen from './provision-app/zofiQProvisionScreen.js';
import Protected from './components/ProtectedRoute.js';
import Login from './provision-app/login.js';
import AuthCallback from './components/AuthCallback';
import CustomerSentiment from './customer-sentiment/customer-sentiment';

import { ThemeProvider, CssBaseline } from '@mui/material';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AiBotTheme } from './themes/theme.ts';
import { AiBotDarkTheme } from './themes/darkTheme.ts';

import ReactGA from "react-ga4";
const TRACKING_ID = "G-GM976S8C47"; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

function App() {
  const [darkMode, setDarkMode] = useState(false);

  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };

  const theme = darkMode ? AiBotDarkTheme : AiBotTheme;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      <Router>
        <Routes>
          <Route path="/" element={<PsaAiBot toggleTheme={toggleTheme} />} />
          <Route path="/aiassist_optin" element={<OptInScreen />} />
          <Route path="/aiassist_optout" element={<OptOutScreen />} />
          <Route path="/landing" element={<AiLanding />} />
          <Route path="/login" element={<Login />} />
          <Route path="/auth-end" element={<AuthCallback />} />
          <Route path="/sentimentpod" element={<CustomerSentiment />} />
          <Route path="/provision" element={
            <Protected>
              <ProvisionScreen />
            </Protected>
          } />
          <Route path="/provision/zofiQ" element={
            <Protected>
              <ZofiQProvisionScreen />
            </Protected>
          } />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}
export default App;